// extracted by mini-css-extract-plugin
export default {"afterpayBtnWrapper":"S7-z","button":"T7-z","disabled":"U7-z","creditCard":"V7-z","wrapper":"W7-z"};